import { mapGetters } from 'vuex'
import i18n from '@/locales'

export default {
  data () {
    let ruleScope = 'cost'
    if (this.$route.path.startsWith('/iam')) {
      ruleScope = 'security'
    }
    return {
      ruleScope,
    }
  },
  computed: mapGetters(['isAdminMode']),
  created () {
    if (!this.isAdminMode) {
      this.singleActions = []
      return
    }
    this.singleActions = [
      {
        label: i18n.t('bill.text_165'),
        permission: 'suggestsysrules_update',
        action: (obj) => {
          this.createDialog('SuggestsysruleCreateDialog', {
            type: 'update',
            ruleScope: this.ruleScope,
            data: [obj],
            columns: [this.columns[0], this.columns[2], this.columns[3]],
            onManager: this.onManager,
            refresh: this.refresh,
          })
        },
        meta: obj => {
          const meta = {
            validate: true,
            tooltip: '',
          }
          return meta
        },
      },
      {
        label: i18n.t('common.more'),
        actions: obj => {
          return [
            {
              label: i18n.t('table.action.clone'),
              permission: 'suggestsysrules_create',
              action: (obj) => {
                this.createDialog('SuggestsysruleCreateDialog', {
                  type: 'clone',
                  ruleScope: this.ruleScope,
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                  refresh: this.refresh,
                })
              },
            },
            {
              label: i18n.t('bill.text_194'),
              permission: 'suggestsysrules_perform_enable',
              action: (obj) => {
                this.createDialog('RuleSetDisabledDialog', {
                  columns: this.columns,
                  data: [obj],
                  onManager: this.onManager,
                  isEnabled: true,
                })
              },
              meta: (obj) => ({
                validate: !obj.enabled,
                tooltip: obj.enabled ? i18n.t('bill.text_216') : '',
              }),
            },
            {
              label: i18n.t('bill.text_196'),
              permission: 'suggestsysrules_perform_disable',
              action: (obj) => {
                this.createDialog('RuleSetDisabledDialog', {
                  columns: this.columns,
                  data: [obj],
                  onManager: this.onManager,
                })
              },
              meta: (obj) => ({
                validate: obj.enabled,
                tooltip: !obj.enabled ? i18n.t('bill.text_217') : '',
              }),
            },
            {
              label: i18n.t('meter.set_scope'),
              permission: 'suggestsysrules_perform_set_public',
              action: (obj) => {
                this.createDialog('SuggestsysruleCreateDialog', {
                  type: 'distribute',
                  ruleScope: this.ruleScope,
                  data: [obj],
                  columns: this.columns,
                  onManager: this.onManager,
                  refresh: this.refresh,
                })
              },
            },
            {
              label: i18n.t('meter.check_immediate'),
              permission: 'suggestsysrules_perform_check',
              action: (obj) => {
                this.createDialog('RuleCheckResourceDialog', {
                  columns: this.columns,
                  data: [obj],
                  onManager: this.onManager,
                })
              },
              meta: (obj) => ({
                validate: obj.enabled,
                tooltip: !obj.enabled ? i18n.t('bill.text_217') : '',
              }),
            },
            {
              label: i18n.t('bill.text_167'),
              permission: 'suggestsysrules_delete',
              action: (obj) => {
                this.createDialog('DeleteResDialog', {
                  vm: this,
                  data: [obj],
                  columns: this.columns,
                  title: i18n.t('bill.text_167'),
                  name: i18n.t('bill.text_174'),
                  onManager: this.onManager,
                })
              },
              meta: (obj) => {
                if (obj.can_delete) {
                  return { validate: true }
                } else {
                  return {
                    validate: false,
                    tooltip: i18n.t('bill.can_not_delete_default_rule'),
                  }
                }
              },
            },
          ]
        },
      },
    ]
  },
}
